var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOnlineIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.7035 3.75H7.1715C7.83343 3.75 8.375 4.27954 8.375 4.9535V9.0093C8.375 9.67123 7.83343 10.2128 7.1715 10.2128H2.7035C2.04158 10.2128 1.5 9.67123 1.5 9.0093V4.9535C1.5 4.29158 2.04158 3.75 2.7035 3.75Z",
    fill: "#354354"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.4046 4.49617C11.4647 4.46007 11.5369 4.42396 11.6092 4.41193C12.0785 4.30361 12.4997 4.66466 12.4997 5.10996V8.82878C12.4997 8.96116 12.4636 9.08151 12.4035 9.18983C12.1989 9.53884 11.7656 9.65919 11.4166 9.4546L9.5271 8.37145V5.57932L11.4046 4.49617Z",
    fill: "#354354"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOnlineIcon);
export default __webpack_public_path__ + "static/media/onlineIcon.f3019866b575411c0151b5ca273340e8.svg";
export { ForwardRef as ReactComponent };